import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { PageHeader } from '../../components/ui/PageHeader';
import { faqs } from '../../data/faq';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <>
      <PageHeader title="Frequently Asked Questions" lead="Answers about installation, charging, choosing a system and warranty." data-id="element-1337" data-mp="2v1fd2b1fw9ib" />
      <div className="mx-auto max-w-site px-5 py-16 md:px-8 md:py-24" data-id="element-1338" data-mp="34tle0a9o619n">
        <ul className="max-w-3xl border-t mf-hairline" data-id="element-1339" data-mp="34vftva63336v">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="border-b mf-hairline" data-id="element-1340" data-mp="3dv2sxpbcbwwr" data-mpi={i}>
                <h2 data-id="element-1341" data-mp="1of3fvx4lpnbu">
                  <button type="button" aria-expanded={isOpen} aria-controls={`faq-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-6 py-6 text-left text-lg font-medium text-white" data-id="element-1342" data-mp="1oea3afiyo3ls">
                    {f.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-titanium transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`} aria-hidden data-id="element-1343" data-mp="1pgcr4ljxv9mp" />
                  </button>
                </h2>
                <AnimatePresence initial={false} data-id="element-1344" data-mp="1y84ukcajpihs">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-1345" data-mp="235wqdheb9or9">
                      <p className="max-w-2xl pb-6 leading-relaxed text-titanium" data-id="element-1346" data-mp="is64cg0vw75t">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
        <p className="mt-10 text-titanium" data-id="element-1347" data-mp="5u84cciw3nbu">
          Still have a question?{' '}
          <Link to="/support" className="font-semibold text-ice hover:underline" data-id="element-1348" data-mp="kqfjgyffxyk9">Contact support</Link>
        </p>
      </div>
    </>;
}